// /src/reuests.js
// ── FALLBACK PUZZLES ──────────────────────────────────────────────────────
// 464 curated Wheel of Fortune-style phrases (3–5 words, no apostrophes)
const fallbackPuzzles = [

    // ── 3 WORD ──────────────────────────────────────────
    "a class act",
    "a clean sweep",
    "a fair shake",
    "a happy medium",
    "a heros welcome",
    "a likely story",
    "a mixed bag",
    "a perfect match",
    "a pretty penny",
    "a red herring",
    "above and beyond",
    "across the board",
    "across the pond",
    "act your age",
    "aged to perfection",
    "agree to disagree",
    "ahead of schedule",
    "alive and kicking",
    "all or nothing",
    "all systems go",
    "all things considered",
    "and theyre off",
    "anything is possible",
    "around the world",
    "at a crossroads",
    "at your service",
    "aye aye captain",
    "baby on board",
    "back to basics",
    "baked fresh daily",
    "barrel of laughs",
    "batteries not included",
    "battle of wills",
    "be my valentine",
    "behind the scenes",
    "believe in yourself",
    "bells and whistles",
    "bend over backwards",
    "best friends forever",
    "better than ever",
    "beyond a doubt",
    "bite your tongue",
    "blaze of glory",
    "body and soul",
    "bright and early",
    "broaden your horizons",
    "built to last",
    "bundle of joy",
    "burst your bubble",
    "bursting with pride",
    "bury the hatchet",
    "business is booming",
    "by your side",
    "cash or credit",
    "catch my drift",
    "caught off guard",
    "change of heart",
    "change of pace",
    "child at heart",
    "clear as mud",
    "coast to coast",
    "cold as ice",
    "come full circle",
    "come what may",
    "cooking with gas",
    "cool as ice",
    "count your blessings",
    "cross my heart",
    "cut and dried",
    "dawn to dusk",
    "do or die",
    "dodged a bullet",
    "done to perfection",
    "drawing a blank",
    "drop dead gorgeous",
    "eager to please",
    "earn your stripes",
    "easy as pie",
    "ebb and flow",
    "end of discussion",
    "enjoy the ride",
    "every second counts",
    "expect the unexpected",
    "face the music",
    "fact or fiction",
    "fall in love",
    "fame and fortune",
    "famous last words",
    "far and wide",
    "feel the heat",
    "first and foremost",
    "flash of genius",
    "flip a coin",
    "floating on air",
    "follow your dreams",
    "follow your heart",
    "food for thought",
    "fools rush in",
    "forgive and forget",
    "full steam ahead",
    "game set match",
    "get a grip",
    "get it done",
    "getting cold feet",
    "gift of gab",
    "give and take",
    "go for broke",
    "go the distance",
    "good as gold",
    "good clean fun",
    "grab a bite",
    "green with envy",
    "grit your teeth",
    "half a dozen",
    "hand over fist",
    "hang in there",
    "happiness is homemade",
    "happy new year",
    "heart of gold",
    "heaven on earth",
    "hip hip hooray",
    "hit the jackpot",
    "hit the sack",
    "home sweet home",
    "horn of plenty",
    "ignorance is bliss",
    "in a heartbeat",
    "in a jiffy",
    "in full bloom",
    "in good faith",
    "in good spirits",
    "in hot pursuit",
    "in mint condition",
    "in seventh heaven",
    "in the groove",
    "in the limelight",
    "into thin air",
    "it takes two",
    "job well done",
    "jump for joy",
    "jump the gun",
    "just a hunch",
    "just for kicks",
    "just my luck",
    "just wing it",
    "keep in touch",
    "keep it simple",
    "keep me posted",
    "keep the change",
    "keep your cool",
    "kick the habit",
    "knock on wood",
    "know the ropes",
    "labor of love",
    "larger than life",
    "laugh it off",
    "let me guess",
    "life is good",
    "like greased lightning",
    "little by little",
    "live and learn",
    "love is blind",
    "made from scratch",
    "make a splash",
    "make a wish",
    "make it happen",
    "mark my words",
    "mind over matter",
    "mind your manners",
    "miss the boat",
    "mix and match",
    "money well spent",
    "my happy place",
    "never say never",
    "no hard feelings",
    "no harm done",
    "no holds barred",
    "no strings attached",
    "nothing but net",
    "now or never",
    "off the charts",
    "off the hook",
    "on a roll",
    "on cloud nine",
    "on the horizon",
    "on the move",
    "on the rocks",
    "one more time",

    // ── 4 WORD ──────────────────────────────────────────
    "a barrel of laughs",
    "a blessing in disguise",
    "a change of scenery",
    "a dime a dozen",
    "a labor of love",
    "a million dollar smile",
    "a night to remember",
    "a sight to behold",
    "a touch of class",
    "a way with words",
    "a word of advice",
    "a work in progress",
    "ace in the hole",
    "adding insult to injury",
    "ahead of the curve",
    "ahead of the game",
    "all eyes on you",
    "all hands on deck",
    "all talk no action",
    "an embarrassment of riches",
    "another day another dollar",
    "apple of my eye",
    "back by popular demand",
    "back in the saddle",
    "back to square one",
    "batten down the hatches",
    "been there done that",
    "behind the eight ball",
    "believe it or not",
    "best of both worlds",
    "better late than never",
    "better safe than sorry",
    "big shoes to fill",
    "bring home the bacon",
    "by word of mouth",
    "call it a day",
    "calm cool and collected",
    "cat got your tongue",
    "caught in the act",
    "close but no cigar",
    "cold hands warm heart",
    "cool as a cucumber",
    "cut to the chase",
    "cute as a button",
    "diamond in the rough",
    "dog days of summer",
    "down to the wire",
    "easier said than done",
    "eat your heart out",
    "every little bit helps",
    "fancy meeting you here",
    "fight fire with fire",
    "first come first served",
    "fit as a fiddle",
    "fit for a king",
    "flash in the pan",
    "for what its worth",
    "forever and a day",
    "four of a kind",
    "free as a bird",
    "fresh as a daisy",
    "from head to toe",
    "from start to finish",
    "get a head start",
    "get in the zone",
    "get to the point",
    "get your act together",
    "give it your all",
    "give me a break",
    "go for the gold",
    "great minds think alike",
    "grin and bear it",
    "happy as a clam",
    "hard as a rock",
    "hats off to you",
    "have the last laugh",
    "head for the hills",
    "here today gone tomorrow",
    "here we go again",
    "hit below the belt",
    "hold down the fort",
    "home away from home",
    "hook line and sinker",
    "hot off the press",
    "in the drivers seat",
    "jack of all trades",
    "jump at the chance",
    "just like old times",
    "keep an open mind",
    "keep the ball rolling",
    "keep your eyes peeled",
    "keep your fingers crossed",
    "kick back and relax",
    "kick up your heels",
    "king of the jungle",
    "knock your socks off",
    "last but not least",
    "let bygones be bygones",
    "let sleeping dogs lie",
    "let the games begin",
    "let your hair down",
    "light as a feather",
    "like father like son",
    "living on easy street",
    "long time no see",
    "look before you leap",
    "loose lips sink ships",
    "love at first sight",
    "love of my life",
    "luck of the draw",
    "mad as a hatter",
    "make yourself at home",
    "match made in heaven",
    "method to the madness",
    "mind your own business",
    "monkey see monkey do",
    "morning noon and night",
    "never a dull moment",
    "new lease on life",
    "nice to meet you",
    "no doubt about it",
    "no harm no foul",
    "nobody does it better",
    "off the beaten path",
    "on a silver platter",
    "on pins and needles",
    "on the cutting edge",
    "on the same page",
    "once bitten twice shy",
    "once more with feeling",
    "one for the books",
    "one in a million",
    "one of a kind",
    "one size fits all",
    "only time will tell",
    "over my dead body",
    "pick up the pace",
    "point of no return",

    // ── 3 WORD ──────────────────────────────────────────
    "practice makes perfect",

    // ── 4 WORD ──────────────────────────────────────────
    "quick as a flash",
    "random acts of kindness",
    "ready willing and able",
    "right here right now",
    "right off the bat",
    "right on the money",
    "right up your alley",
    "run a tight ship",
    "same old same old",
    "save room for dessert",
    "set the record straight",
    "sharp as a tack",
    "shoot for the moon",
    "show me the money",
    "sit back and relax",
    "sleep like a baby",
    "sly as a fox",
    "smart as a whip",
    "so far so good",
    "solid as a rock",
    "step on the gas",
    "stop on a dime",
    "straight from the heart",
    "stubborn as a mule",
    "take a back seat",
    "take a rain check",
    "take care of yourself",
    "talk of the town",
    "that hits the spot",
    "thats my final answer",
    "the coast is clear",
    "the future is now",
    "the jig is up",
    "the key to success",
    "the moment of truth",
    "the more the merrier",
    "the next big thing",
    "the pressure is on",
    "the skys the limit",
    "the time has come",
    "the whole nine yards",
    "things are looking up",
    "think outside the box",
    "third times the charm",
    "time and time again",
    "time is running out",
    "top of the charts",
    "tricks of the trade",
    "turn back the clock",
    "two of a kind",
    "uncle sam wants you",
    "up in the air",
    "up to no good",
    "water under the bridge",
    "what are friends for",
    "what are the odds",

    // ── 3 WORD ──────────────────────────────────────────
    "winner takes all",

    // ── 4 WORD ──────────────────────────────────────────
    "words to the wise",
    "works like a charm",
    "you be the judge",
    "you can do it",
    "you have my word",
    "you live and learn",
    "you melt my heart",
    "your place or mine",

    // ── 5 WORD ──────────────────────────────────────────
    "actions speak louder than words",
    "age is just a number",
    "all bark and no bite",
    "as luck would have it",
    "back to the drawing board",
    "based on a true story",
    "break free from the ordinary",
    "buy one get one free",
    "chip off the old block",
    "come hell or high water",
    "cut from the same cloth",
    "dont beat around the bush",
    "easy as one two three",
    "every dog has his day",
    "everything happens for a reason",
    "feel like a million bucks",
    "follow it to the letter",
    "for a limited time only",
    "for all intents and purposes",
    "fun for the whole family",
    "get a grip on yourself",
    "get down to brass tacks",
    "give it your best shot",
    "going from bad to worse",
    "hang on to your hats",
    "head over heels in love",
    "honesty is the best policy",
    "horse of a different color",
    "how the other half lives",
    "in the nick of time",
    "it takes two to tango",
    "just another day in paradise",
    "just between you and me",
    "keep up the good work",
    "laughter is the best medicine",
    "life is full of surprises",
    "live life to the fullest",
    "look on the bright side",
    "love is in the air",
    "money doesnt grow on trees",
    "more than meets the eye",
    "my compliments to the chef",
    "never in a million years",
    "never in my wildest dreams",
    "once in a blue moon",
    "one step at a time",
    "one thing leads to another",
    "put your best foot forward",
    "quit while you are ahead",
    "saving the best for last",
    "spring is in the air",
    "stop and smell the roses",
    "straight from the horses mouth",
    "take it or leave it",
    "take my word for it",
    "the cream of the crop",
    "the elephant in the room",
    "the grass is always greener",
    "the icing on the cake",
    "the whole ball of wax",
    "the world is your oyster",
    "throw caution to the wind",
    "too big for your britches",
    "too good to be true",
    "two peas in a pod",
    "until the cows come home",
    "we make a great team",
    "what goes around comes around",
    "when push comes to shove",
    "you are what you eat",
    "you can count on me",
    "you cant fight city hall",
]

// ── SHUFFLE ───────────────────────────────────────────────────────────────
const shuffle = (arr) => {
    const a = [...arr]
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]]
    }
    return a
}

// ── PERSISTENT SHUFFLE QUEUE ──────────────────────────────────────────────
// Stores a shuffled index array in localStorage.
// Each game pops the next index — no repeats until all 464 exhausted,
// then reshuffles automatically.
const LS_KEY = 'hm_queue'

const getQueue = () => {
    try {
        const stored = JSON.parse(localStorage.getItem(LS_KEY))
        if (Array.isArray(stored) && stored.length > 0) return stored
    } catch {}
    return null
}

const saveQueue = (queue) => {
    localStorage.setItem(LS_KEY, JSON.stringify(queue))
}

const getNextFallback = () => {
    let queue = getQueue()
    if (!queue) {
        queue = shuffle([...Array(fallbackPuzzles.length).keys()])
        saveQueue(queue)
    }
    const index = queue.pop()
    saveQueue(queue)
    return fallbackPuzzles[index]
}

// ── GET PUZZLE ────────────────────────────────────────────────────────────
const getPuzzle = async (wordCount = 4) => {
    try {
    
        const response = await fetch(`/.netlify/functions/getPuzzle?wordCount=${wordCount}`)
        if (response.status === 200) {
            const data = await response.json()
            return data.puzzle
        }
        throw new Error('Bad response.')
    } catch (e) {
        console.warn('Puzzle API unavailable, using fallback.', e)
        return getNextFallback()
    }
}

export { getPuzzle as default }